module.exports = __webpack_public_path__ + "static/media/xmark.ec9347fb.svg";